import { EventEmitter, h, Component, Host, Event, Element } from '@stencil/core';
import { ClickOutside } from 'stencil-click-outside';

import type { TableStateInterface } from '../../../../services/interfaces';
import { getTableState } from '../helpers/table-state';

@Component({
  tag: 'pk-table-body',
  styleUrl: './scss/pk-table-body.scss',
  scoped: true,
})
export class PkTableBody {
  // Own Properties
  // ====================

  private tableState: TableStateInterface;

  // Reference to host HTML element
  // ===================================

  @Element() el!: HTMLPkTableBodyElement;

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  /** Handler to be called when the table body lost focus */
  @Event({ eventName: 'pkTableBodyBlur' }) pkTableBodyBlur: EventEmitter;

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  componentWillLoad() {
    const tableId = this.el.closest<HTMLPkTableElement>('pk-table[table-id]')?.tableId;
    this.tableState = getTableState(tableId);
  }

  // Listeners
  // ==============

  @ClickOutside()
  onPkTableBodyBlurEvent(ev?: Event) {
    this.pkTableBodyBlur.emit(ev);
  }

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // ==========================

  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    if (!this.tableState) return null;

    const { isLoading, useFixedWidth } = this.tableState;

    return (
      <Host class={{ 'pk-table--body': true, 'fixed-width': useFixedWidth }} role="rowgroup">
        <slot />
        {isLoading && (
          <div class={{ 'pk-table--body-loader': true, 'is-loading': true }}>
            <pk-spinner />
          </div>
        )}
      </Host>
    );
  }
}
